import {
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";
import { checkResponse } from "../utils/checkResponse";
import jwt from "jsonwebtoken";

import { Cookies } from "react-cookie";
const cookie = new Cookies();
const serviceCost = {
  state: {
    serviceCost: [],
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: (dispatch) => ({
    async getServiceCost(payload, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/serviceCost/getServiceCost";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({ applyDate: payload }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ serviceCost: result.data });
          else _this.setState({ serviceCost: [] });
          return result;
        })
        .catch((error) => {
          _this.setState({ serviceCost: [] });
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateServiceCost(payload, rootState) {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/serviceCost/updateServiceCost";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default serviceCost;
